<template>
  <div id="app">
    <div class="main">
      <el-card class="box-card leftcon left">
        <div class="left-con">
          <div class="pd" v-if="subject.judge_status">
            <div class="title">判 断</div>
            <div v-for="(item,key) in subject.list.judge.local" :key="'panduan1'+key" class="con" :id="'panduan1-'+key">
              <b>{{'第 ' + (key+1) + ' 题'}}</b>
              <div class="option">

                <p class="optionitem">{{item.name}}</p>
                <el-radio-group v-model="temp['local'][key]">
                  <el-radio label="1" @change="change('judge','local', key,'1')">正确</el-radio>
                  <el-radio label="0" @change="change('judge','local', key,'0')">错误</el-radio>
                </el-radio-group>
                <div class="optionanswer">
                  您的答案：{{item.user_answer}}<br>
                  正确答案：{{item.answer}}<br>
                  解析：{{item.info}}
                </div>
              </div>
            </div>
            <div v-for="(item,key) in subject.list.judge.public" :key="'panduan2'+key" class="con" :id="'panduan2-'+key">
              <b>{{'第 ' +( subject.list.judge.local.length+key+1 )+ ' 题'}}</b>
              <div class="option">

                <p class="optionitem">{{item.name}}</p>
                <el-radio-group v-model="temp['public'][key]">
                  <el-radio label="1" @change="change('judge','public', key,'1')">正确</el-radio>
                  <el-radio label="0" @change="change('judge','public', key,'0')">错误</el-radio>
                </el-radio-group>
                <div class="optionanswer">
                  您的答案：{{item.user_answer}}<br>
                  正确答案：{{item.answer}}<br>
                  解析：{{item.info}}
                </div>
              </div>
            </div>
          </div>
          <div class="xz" v-if="subject.select_status">
            <div class="title">选 择</div>
            <div v-for="(item,key) in subject.list.select.local" :key="'xuanze1'+key" class="con" :id="'xuanze1-'+key">
              <b v-if="item['answer'].length>1">{{'第 ' + (key+1)+ ' 题 '+' [多选]'}}</b>
              <b v-else="item['answer'].length>1">{{'第 ' + (key+1)+ ' 题 '+' [单选]'}}</b>
              <div class="option">

                <p class="optionitem">{{item.name}}</p>

                       <el-checkbox  v-for="(i,key1) in item['choice']"  :key="key1" :label="i" style="width: 100%;" @change="change('select','local', key,key1)">
                         {{options[key1]}}.{{i}}
                 </el-checkbox>
                 <div class="optionanswer" >
                    <p>您的答案：<nobr v-for="(i1,key) in item['user_answer']" :key="key">{{i1}}</nobr> </p>
                   <p style=" margin-top: -12px;"> 正确答案：<nobr  v-for="(i1,key) in item['answer']" :key="key" >{{i1}}</nobr></p>
                   <p style=" margin-top: -12px;"> 解析：{{item.info}}</p>
                </div>
              </div>
            </div>
            <div v-for="(item,key) in subject.list.select.public" :key="'xuanze2'+key" class="con"  :id="'xuanze2-'+key">
              
              <b v-if="item['answer'].length>1">{{'第 ' + (key+1)+ ' 题 '+' [多选]'}}</b>
              <b v-else="item['answer'].length>1">{{'第 ' + (key+1)+ ' 题 '+' [单选]'}}</b>
              <div class="option">
                <p class="optionitem">{{item.name}}</p>

                    <el-checkbox v-for="(i,key1) in item['choice']"  :key="key1" :label="i" style="width: 100%;" @change="change('select','public', key,key1)">
                         {{options[key1]}}.{{i}}
                    </el-checkbox>
                 <div class="optionanswer">
                  <p>您的答案：<nobr v-for="(i1,key) in item['user_answer']" :key="key">{{i1}}</nobr> </p>
                   <p style=" margin-top: -12px;"> 正确答案：<nobr  v-for="(i1,key) in item['answer']" :key="key" >{{i1}}</nobr></p>
                   <p style=" margin-top: -12px;"> 解析：{{item.info}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-card>


      <div class=" rightcon right">
        <el-card class="box-card">
          <div class="rightconhead">
            <div>答题卡</div>
            <time>总分：{{subject.score}}分</time>
          </div>
          <div class="right-con">
            <div class="detail">
              <div class="detailleft">姓名</div>
              <div class="">：   {{info.rale_name}}</div>
              <div class="detailleft">总题数</div>
              <div class="">： {{subject.count}}题</div>

              <div class="detailleft">答对题数</div>
              <div class="">：   {{subject.t}}题</div>
            </div>
            <div style=" max-height: calc( 100vh - 340px); overflow: auto;">
               <div class="title" style="margin-top: 0;">判 断</div>
              <div class="num" v-if="subject.judge_status">
                 <el-button type="primary" plain v-for="(item,key) in subject.list.judge.local" :key="'panduan11'+key"  :id="'judge_local_'+key"  @click="buttonitem('#panduan1-'+key)">{{key+1}}</el-button>
                 <el-button type="primary" plain v-for="(item,key) in subject.list.judge.public" :key="'panduan12'+key"  :id="'judge_public_'+key"  @click="buttonitem('#panduan2-'+key)">{{(subject.list.judge.local.length+key+1)}}</el-button>
              </div>
              <div class="title">选 择</div>
              <div class="num"  v-if="subject.select_status" >
                <el-button type="primary" plain   v-for="(item,key) in subject.list.select.local" :key="'xaunze11'+key"  :id="'select_local_'+key" @click="buttonitem('#xuanze1-'+key)">{{key+1}}</el-button>
                <el-button type="primary" plain   v-for="(item,key) in subject.list.select.public" :key="'xuanzze12'+key" :id="'select_public_'+key" @click="buttonitem('#xuanze2-'+key)">{{(subject.list.select.local.length+key+1)}}</el-button>
              </div>
            </div>
          </div>
          <el-button class="sub" type="primary" @click="$router.push('/tasklist')">返回</el-button>
        </el-card>

      </div>



    </div>

  </div>
</template>

<script>
  export default {
    name: 'App',
     props: {
        time: {
            type: Number,
            default: 0
        }
    },
    data() {
      return {
        info:this.$store.state.info,
        options: ['A', 'B', 'C', 'D','E','F','G','H','I'],
        plan:{
          num:this.$route.query.num,
          type:'subject',
        },
        subject:{
          list:[],
          num:this.$route.query.num,
          judge_status:false,
          select_status:false,
          score:'',//的分数
          count:'',//总题数
          t:'',//答对题数
        },
        temp:{
          local:[],
          public:[]
        },
      }
    },
    components: {},
    mounted () {
       this.get_task_info();
       },
    updated(){
      //.judge.local设置颜色
      for(let i=0;i< this.subject.list.judge.local.length;i++){
        if(this.subject.list.judge.local[i].answer !=this.subject.list.judge.local[i].user_answer){
         document.getElementById('judge_local_'+i).style.backgroundColor="red";
  }else{
     document.getElementById('judge_local_'+i).style.backgroundColor="	#00FF00";
  }
}        //.judge.public设置颜色
      for(let i=0;i< this.subject.list.judge.public.length;i++){
       if(this.subject.list.judge.public[i].answer !=this.subject.list.judge.public[i].user_answer){
        document.getElementById('judge_public_'+i).style.backgroundColor="red";
  }else{
     document.getElementById('judge_public_'+i).style.backgroundColor="	#00FF00";
  }

}         //select.public设置颜色
      for(let i=0;i< this.subject.list.select.public.length;i++){
       if(this.subject.list.select.public[i].answer.length !=this.subject.list.select.public[i].user_answer.length){
        document.getElementById('select_public_'+i).style.backgroundColor="red";
        }else{
       if(this.subject.list.select.public[i].answer.length==1){
        if(this.subject.list.select.public[i].answer !=this.subject.list.select.public[i].user_answer){
          document.getElementById('select_public_'+i).style.backgroundColor="red";
        }else{
          document.getElementById('select_public_'+i).style.backgroundColor="#00FF00";
        }
       }else{
          for(let j=0;j<this.subject.list.select.public[i].answer.length;j++){
             if(this.subject.list.select.public[i].answer[j] !=this.subject.list.select.public[i].user_answer[j]){
             document.getElementById('select_public_'+i).style.backgroundColor="red";
             break;
         }else{
           document.getElementById('select_public_'+i).style.backgroundColor="#00FF00";
         }
          }
       }
  }

}        //.select.local.设置颜色
      for(let i=0;i< this.subject.list.select.local.length;i++){
       if(this.subject.list.select.local[i].answer.length !=this.subject.list.select.local[i].user_answer.length){
        document.getElementById('select_local_'+i).style.backgroundColor="red";
        }else{
       if(this.subject.list.select.local[i].answer.length==1){
        if(this.subject.list.select.local[i].answer !=this.subject.list.select.local[i].user_answer){
          document.getElementById('select_local_'+i).style.backgroundColor="red";
        }else{
          document.getElementById('select_local_'+i).style.backgroundColor="#00FF00";
        }
       }else{
          for(let j=0;j<this.subject.list.select.local[i].answer.length;j++){
             if(this.subject.list.select.local[i].answer[j] !=this.subject.list.select.local[i].user_answer[j]){
             document.getElementById('select_local_'+i).style.backgroundColor="red";
             break;
         }else{
           document.getElementById('select_local_'+i).style.backgroundColor="#00FF00";
         }
        }
       }
  }
}
},
    methods: {
      goback(){
        this.$router.push({path:'/Tasklist'})
      },
        get_task_info(){
              let _this=this;
        _this.axios.get('/v2/user_task/get_subject_result_info',{
          params: {num: _this.subject.num },}
        ).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.subject.list=res.data.data.subject;
               _this.subject.count=res.data.data.count;
               _this.subject.t=res.data.data.t;
               _this.subject.score=(100/_this.subject.count*_this.subject.t).toFixed(2)    ;
               if((res.data.data.subject.judge.local.length+res.data.data.subject.judge.public.length)>0){
                _this.subject.judge_status=true;
                _this.setxzitem('judge','local');
                 _this.setxzitem('judge','public');
              }
              if((res.data.data.subject.select.local.length+res.data.data.subject.select.public.length)>0){
                _this.subject.select_status=true;
                _this.setxzitem('select','public');
                _this.setxzitem('select','local')
              }
            }else{
              _this.$message.error(res.data.msg);
            }
          }else{
            _this.$message.error('服务器内部错误');
          }
        })
      },
      //设置字符串
      setxzitem(type,val){
        let _this=this
        if(type=='select'){
          for(let i=0;i< _this.subject.list.select[val].length;i++){
            let temp= _this.subject.list.select[val][i]
             temp['choice']=temp['choice'].split('----')
            _this.subject.list.select[val][i]=temp
            if(_this.subject.list.select[val][i].answer.length != 1){
               let temp1= _this.subject.list.select[val][i]
               temp1['answer']=temp1['answer'].split('----')
               _this.subject.list.select[val][i]=temp1
            }
            if(_this.subject.list.select[val][i].user_answer.length == 0){
               _this.subject.list.select[val][i].user_answer="空"
            }else if(_this.subject.list.select[val][i].user_answer.length != 1){
               let temp1= _this.subject.list.select[val][i]
               temp1['user_answer']=temp1['user_answer'].split('----')
               _this.subject.list.select[val][i]=temp1
            }
          }
        }else{
          for(let i=0;i< _this.subject.list.judge[val].length;i++){
            if(_this.subject.list.judge[val][i].answer == "0" ){
               _this.subject.list.judge[val][i].answer="错误"
            }else if(_this.subject.list.judge[val][i].answer == "1"){
                _this.subject.list.judge[val][i].answer="正确"
            }
                if( _this.subject.list.judge[val][i].user_answer == "0"){
               _this.subject.list.judge[val][i].user_answer="错误"
            }else if(_this.subject.list.judge[val][i].user_answer == "1"){
                 _this.subject.list.judge[val][i].user_answer="正确"
            }else{
              _this.subject.list.judge[val][i].user_answer="空"
            }
          }
        }

      },
      //锚点跳转
      buttonitem(selector){
          var anchor = this.$el.querySelector(selector)
         document.documentElement.scrollTop =anchor.offsetTop
      },

    }

  }
</script>

<style scoped>
  /* 交卷 */
  >>>.sub {
    width: calc(100% - 40px);
    margin: 0px 20px;
  }

  >>>.el-checkbox__label {
    display: inline;
  }

  >>>.el-checkbox, .el-checkbox__input {
    white-space: normal;
  }

  .main {
    min-height: calc(100vh - 40px);
    height: 100%;
    width: 70%;
    padding: 20px;
    margin: 0 15%;
    z-index: 100;
    position: relative;
    overflow: hidden;
    :#2add9c
  }

  /* 左侧 */
  .leftcon {
    width: calc(70% - 20px);
    padding: 0;
    background-color: white;
    min-height: calc(100vh - 40px);
    z-index: 1000;
    margin-bottom: 20px;
  }

  .left-con {
    padding: 20px;
    padding-top: 0;
  }

  .title {
    background-color: #f6f8ff;
    line-height: 50px;
    height: 50px;
    font-size: 18px;
    font-weight: 600;
    padding: 0 20px;
    margin-top: 20px;
  }

  .con {
    padding: 20px;
    margin: 3px 0;
    border: 1px solid gainsboro;
  }

  .option {
    padding-left: 20px;
  }

  .optionitem {
    border-bottom: 1px solid gainsboro;
    padding: 5px;
    margin-top: 0;
  }
  .optionanswer{
    font-size: 15px;
    margin-top: 20px;
  }

  /* 交卷 */
  >>>.sub {
    width: calc(100% - 40px);
    margin: 0px 20px;
  }

  /* 右侧 */
  .rightcon {
    width: 20%;
    background-color: white;
    position: fixed;
    top: 20px;
    right: 15%;
  }
  >>>.el-card__body {
    padding: 0;
    margin-bottom: 20px;
  }

  .right-con {
    padding: 20px;
  }

  .rightconhead {
    overflow: auto;
  }

  .detail {
    background-color: #f6f8ff;
    margin-bottom: 20px;
    padding: 20px;
  }

  .detailleft {
    width: 80px;
    margin-right: 10px;
    float: left;
    text-align-last:justify;
text-align:justify;
text-justify:distribute-all-lines;
  }

  time {
    background-color: #409EFF;
    width: 50%;
    float: right;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #f50000;
    font-weight: 600;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .rightconhead>div {
    float: left;
    width: 50%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-weight: 600;
    background-color: #f6f8ff;
  }

  .num {
    padding: 0 10px;
    border: 2px solid #f6f8ff;
    border-top: none;
    width: calc( 100% - 24px );
    box-shadow: 5px 5px 5px #f6f8ff;
  }

  .num>.el-button {
    text-align: center;
    padding: 10px 5px;
    margin: 10px 5px;
    width: 35px;
    height: 35px;
  }
</style>



// WEBPACK FOOTER //
// src/view/index/Task/TasksubjeCtresult.vue